/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    uploadImage(payload, onUploadProgress) {
        return HttpService.post(environment.API_UPLOAD_IMAGE, payload, {
            onUploadProgress,
        });
    },
    uploadPublicImage(payload, onUploadProgress) {
        return HttpServiceNoToken.post(
            environment.API_PUBLIC_UPLOAD_IMAGE,
            payload,
            {
                onUploadProgress,
            }
        );
    },
    deleteImage(id) {
        return HttpService.delete(environment.API_UPLOAD_IMAGE + `/${id}`);
    },
    deletePublicImage(id) {
        return HttpServiceNoToken.delete(
            environment.API_PUBLIC_UPLOAD_IMAGE + `/${id}`
        );
    },
    getImage(id) {
        return HttpService.get(environment.API_UPLOAD_IMAGE + `/${id}`);
    },
    getImageNoSecure(id) {
        return HttpServiceNoToken.get(
            environment.API_UPLOAD_IMAGE_NOT_SECURE + `/${id}`
        );
    },
    getCustomerRole() {
        return HttpService.get(environment.API_CUSTOMER_ROLE);
    },
    getRequestType() {
        return HttpService.get(environment.API_REQUEST_TYPE);
    },
    getPublicRequestType() {
        return HttpServiceNoToken.get(environment.API_PUBLIC_REQUEST_TYPE);
    },
    getDomain() {
        return HttpService.get(environment.API_DOMAIN);
    },
    getDomainVerify() {
        return HttpService.get(environment.API_DOMAIN_WORKFLOW_VERIFICATION);
    },
    getCompanyList() {
        return HttpService.get(
            environment.API_WFSECURE + '/company/domainlist'
        );
    },
    uploadDoc(payload) {
        return HttpService.post(environment.API_UPLOAD_DOC, payload, {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
            },
        });
    },
    uploadPublicDoc(payload) {
        return HttpServiceNoToken.post(
            environment.API_PUBLIC_UPLOAD_DOC,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                },
            }
        );
    },
    downloadDoc(id) {
        return HttpService.get(environment.API_UPLOAD_DOC + `/${id}`, {
            responseType: 'blob',
        });
    },
    deleteDoc(id) {
        return HttpService.delete(environment.API_UPLOAD_DOC + `/${id}`);
    },
    deleteFile(id) {
        return HttpService.delete(environment.API_UPLOAD_FILE + `/${id}`);
    },
    deletePublicFile(id) {
        return HttpServiceNoToken.delete(
            environment.API_PUBLIC_UPLOAD_FILE + `/${id}`
        );
    },
    getSecret() {
        return HttpService.get(environment.API_SECRET);
    },
    getDataHubPlatform() {
        return HttpService.get(environment.API_DATA_HUB_PLATFORM);
    },
    getDataHubDb(platFormId) {
        return HttpService.get(environment.API_DATA_HUB_DB + '/' + platFormId);
    },
    getDsTypeDropdown() {
        return HttpService.get(environment.API_WORKFLOW_M_DS_TYPE);
    },
    getStateDropdown() {
        return HttpService.get(environment.API_WORKFLOW_M_STATE);
    },
    getDs() {
        return HttpService.get(environment.API_DS);
    },
    getDatahubURL() {
        return HttpService.get(environment.API_DATAHUB_URL);
    },
    getOrganizeAdmin() {
        return HttpService.get(environment.API_ORGANIZE_ADMIN);
    },
    getStatus(params) {
        return HttpService.get(environment.API_STATUS, {
            params,
        });
    },
    getOtpByEmail(payload) {
        return HttpService.post(environment.API_OTP_BY_EMAIL, payload);
    },
    // Verify OTP
    verifyOtp(payload) {
        return HttpService.post(environment.API_VERIFY_OTP, payload, {
            headers: { Authorization: null },
        });
    },
    getReleaseDetail(releaseId) {
        return HttpService.get(environment.API_RELEASE + '/' + releaseId);
    },
    getReleaseList() {
        return HttpService.get(environment.API_RELEASE + '/' + 'dropdown');
    },
};
